import { getUserBranches, getSelectedBranchId, setSelectedBranchId } from '@/store/api'

/**
 * Populates the branch selector dropdown in the Data Hub view.
 */
export function populateDataHubBranchSelector(): void {
  const branchSelect = document.getElementById('data-hub-branch-select') as HTMLSelectElement | null
  if (!branchSelect) return

  const userBranches = getUserBranches()
  const selectedBranchId = getSelectedBranchId()

  if (userBranches.length === 0) {
    branchSelect.innerHTML = '<option value="" disabled>No branches available</option>'
    branchSelect.disabled = true
    return
  }

  branchSelect.innerHTML = userBranches
    .map((branch) => `<option value="${branch.branchId}">${branch.branchName}</option>`)
    .join('')

  branchSelect.value = selectedBranchId && userBranches.some((b) => b.branchId === selectedBranchId)
    ? selectedBranchId
    : userBranches[0]?.branchId || ''

  branchSelect.disabled = false

  branchSelect.onchange = () => {
    setSelectedBranchId(branchSelect.value)
  }
}
